<template>
    <div>
      <h1 class="page-header">{{ $t('comment.comment') }}</h1>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12">
          <ts-loading-banner :loading="loading">
            <ts-card>
              <ts-card-wrapper>
                <div class="form-group m-b-15">
                  <label class="required">{{ $t('comment.comment') }}</label>
                  <textarea
                  v-model="model.comment"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('comment') }"
                  rows="2"
                ></textarea>
                  <div class="invalid-feedback" v-if="errors.has('comment')">
                    {{ errors.first('comment') }}
                  </div>
                </div>
                <div class="form-group m-b-15">
                  <label>{{ $t('comment.orderNumber') }}</label>
                  <input
                    v-model.number="model.order_number"
                    type="number"
                    class="form-control"
                  />
                </div>
                <div class="text-right">
                  <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                    {{ $t('cancel') }}
                  </ts-button>
                  <ts-button
                    v-if="updating"
                    class="btn-primary"
                    :waiting="waiting"
                    @click.prevent="update"
                  >
                    {{ $t('update') }}
                  </ts-button>
                  <ts-button
                    v-if="!updating"
                    :waiting="waiting"
                    class="btn-primary"
                    @click.prevent="store"
                    >{{ $t('save') }}</ts-button
                  >
                </div>
              </ts-card-wrapper>
            </ts-card>
          </ts-loading-banner>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-12">
          <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex'
  import DataTable from './table'
  import { Errors } from 'form-backend-validation'

  export default {
    name: 'comment-form',
    components: {
      DataTable
    },
    data() {
      return {
        model: {
          comment: null,
          order_number: null,
        },
        errors: new Errors(),
        waiting: false,
        fetch: false,
        updating: false,
        loading: false
      }
    },
    created() {
      this.setEditData()
    },
    computed: {
      ...mapState('comment', ['edit_data'])
    },
    methods: {
      store() {
        this.errors = new Errors()
        this.waiting = true
        this.$store
          .dispatch('comment/store', this.model)
          .then(response => {
            this.clearInput()
            this.$toasted.success(response.message)
            this.waiting = false
            this.fetch = true
          })
          .catch(error => {
            this.errors = new Errors(error.errors)
            this.$toasted.error(error.message)
            this.waiting = false
          })
      },
      update() {
        this.errors = new Errors()
        this.waiting = true
        this.$store
          .dispatch('comment/update', this.model)
          .then(response => {
            this.$toasted.success(response.message)
            this.waiting = false
            this.fetch = true
            this.cancel()
          })
          .catch(error => {
            this.errors = new Errors(error.errors)
            this.$toasted.error(error.message)
            this.waiting = false
          })
      },
  
      cancel() {
        this.updating = false
        this.$store.commit('comment/SET_EDIT_DATA', {})
        this.$router.push({ name: 'comment' })
        this.clearInput()
      },
      clickBackURL() {
        this.$store.commit('comment/SET_EDIT_DATA', {})
        this.clearInput()
        this.fetch = true
        this.updating = false
      },
      async setEditData() {
        this.loading = true
        if (!_.isEmpty(this.edit_data)) {
          this.errors = new Errors()
          this.model = _.clone(this.edit_data)
          this.updating = true
        }
        this.loading = false
      },
      clearInput() {
        this.model = {
          ac_st_id: '',
          study_time: '',
          session: ''
        }
      }
    },
    watch: {
      edit_data: {
        handler() {
          this.setEditData()
        }
      }
    },
    beforeRouteLeave(to, from, next) {
      if (_.isEmpty(to.params)) {
        this.$store.commit('comment/RESET_STATE')
        this.clickBackURL()
      }
      next()
    }
  }
  </script>
  